<p-overlayPanel #op [dismissable]="true" [showCloseIcon]="true" styleClass="catalog-selection-overlay">
  <p-tree [value]="projectTaskTree" selectionMode="single" [style]="{'width':'100%'}" [styleClass]="'tree-container'" [(selection)]="selectedTask" (onNodeSelect)="onNodeSelect($event, op)">
  </p-tree>
</p-overlayPanel>
<div>
  <button pButton type="button" class="button-icon" icon="fa fa-search" (click)="op.toggle($event)"></button>
</div>
